import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-pagination-results-text': {
    margin: 0,
  },
});
